import axios from 'src/utils/axios';
import moment from 'moment';

export const GET_METRICS = '@analytics-actions/get-metrics';
export const SET_DATE_RANGE = '@analytics-actions/set-date-range';

// Agent availability metrics action types
export const FETCH_AGENT_AVAILABILITY_METRICS_REQUEST =
  '@analytics-actions/fetch-agent-availability-metrics-request';
export const FETCH_AGENT_AVAILABILITY_METRICS_SUCCESS =
  '@analytics-actions/fetch-agent-availability-metrics-success';
export const FETCH_AGENT_AVAILABILITY_METRICS_FAILURE =
  '@analytics-actions/fetch-agent-availability-metrics-failure';

export function fetchMetrics(botId, dateRange) {
  const startDate = moment(dateRange[0]).format('YYYY-MM-DD');
  const endDate = moment(dateRange[1]).format('YYYY-MM-DD');
  const request = axios.get(`/api/analytics/${botId}`, {
    params: {
      channel: 'all',
      start: startDate,
      end: endDate
    }
  });

  return dispatch => {
    request.then(response => {
      dispatch({
        type: GET_METRICS,
        payload: response.data
      });
    });
  };
}

export function setDateRange(dateRange) {
  return dispatch =>
    dispatch({
      type: SET_DATE_RANGE,
      payload: { dateRange }
    });
}

export function fetchAgentAvailabilityMetrics(
  botId,
  dateRange,
  staffId = null
) {
  const startDate = moment(dateRange[0]).format('YYYY-MM-DD');
  const endDate = moment(dateRange[1]).format('YYYY-MM-DD');

  const params = {
    startDate,
    endDate
  };

  if (staffId) {
    params.staffId = staffId;
  }

  return dispatch => {
    dispatch({
      type: FETCH_AGENT_AVAILABILITY_METRICS_REQUEST
    });

    const request = axios.get(`/api/analytics/${botId}/agent-availability`, {
      params
    });

    request
      .then(response => {
        dispatch({
          type: FETCH_AGENT_AVAILABILITY_METRICS_SUCCESS,
          payload: response.data
        });
      })
      .catch(error => {
        console.error('Agent availability metrics error:', error);
        dispatch({
          type: FETCH_AGENT_AVAILABILITY_METRICS_FAILURE,
          payload:
            error.response?.data?.message ||
            'Failed to fetch agent availability metrics'
        });
      });
  };
}
